import styled, { css } from 'styled-components';
import { resetBtn } from 'styled-manila';
import { getColor } from 'core/utils/Styles';
import Button from 'core/ui/Button';

export const breakpoint = '(min-width: 620px)';
export const btnBreakpoint = '(min-width: 768px)';

const baseText = css`
	color: ${getColor("gray")};
	letter-spacing: 0.2px;
`;

export const contentPadding = css`
	padding: 12px;

	@media ${breakpoint} {
		padding: 24px;
	}
`;

export const ModalWrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	max-height: 100%;
	margin-left: auto;
	margin-right: auto;
	min-width: 300px;
	max-width: ${({ maxWidth }) => maxWidth || "620px"};
	background-color: ${getColor('white')};
	border-radius: 4px;
	position: relative;
	width: 100vw;

	@media ${breakpoint} {
		margin-top: 16px;
		margin-bottom: 24px;
		width: 92vw;
		height: auto;
	}
`;

export const Header = styled.header`
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-bottom: 1px solid ${getColor('alto')};
	${contentPadding}

	${({ clean }) => clean && css`
		border-bottom: none;
		@media (min-width: 1024px) {
			border-bottom: none;
		}
	`}
`;

export const Title = styled.h4`
	${baseText}
	margin: 0 28px 0 0;

	@media ${breakpoint} {
		font-size: 19px;
	}
`;

export const BodyContent = styled.section`
	${baseText}
	${contentPadding}
	font-size: 14px;
	overflow-y: auto;

	${({ $flex }) => $flex && css`
		flex: ${$flex};
	`}

	${({ clean }) => clean && css`
		@media ${breakpoint} {
			padding-top: 0;
		}
	`}

	@media ${breakpoint} {
		font-size: 16px;
	}
`;

export const Footer = styled.footer`
	${baseText}
	margin-top: 24px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-direction: column;

	@media ${btnBreakpoint} {
		flex-direction: row-reverse;
	}
`;

export const FooterNote = styled.p`
	${baseText}
	margin: 16px 0 0;
	text-align: center;
	font-size: 13px;
	line-height: 1.7;

	@media ${btnBreakpoint} {
		margin: 0;
		text-align: left;
		padding-right: 32px;
	}
`;

export const FooterLink = styled.button.attrs({
	type: 'button'
})`
	${resetBtn}
	color: ${getColor('darkTeal')};
	font-weight: 600;

	&:hover, &:focus {
		color: ${getColor('limedSpruceGray')};
	}

	&[disabled] {
		cursor: not-allowed;
		opacity: 0.8;
	}
`;

export const DismissBtn = styled.button`
	${resetBtn}
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	right: 10px;
	color: ${getColor('alto')};
	padding: ${({ padding }) => padding || "10px"};
`;

export const SubmitButton = styled(Button)`
	width: 100%;
	white-space: nowrap;
	pointer-events: auto;

	&.disabled,
	&[disabled] {
		cursor: not-allowed;
	}

	@media ${btnBreakpoint} {
		width: auto;
	}
`;
